(function () {
    var apiReadyCallbacks = [];

    if (typeof window.onYouTubeIframeAPIReady === 'function' && !Object.getOwnPropertyDescriptor(window, "onYouTubeIframeAPIReady").get) {
        apiReadyCallbacks.push(window.onYouTubeIframeAPIReady);
    }

    var currentlyBeingCalled = false;
    var onYouTubeIframeAPIReady = function () {
        if (currentlyBeingCalled) return; // Prevent callback loop
        else {
            currentlyBeingCalled = true;
            apiReadyCallbacks.forEach(cb => {
                cb();
            });
            currentlyBeingCalled = false;
        }
    };
    
    // Wrap window.onYouTubeIframeAPIReady to allow multiple callbacks to be defined without overwriting existing ones.
    Object.defineProperty(
        window,
        'onYouTubeIframeAPIReady', {
            get: () => onYouTubeIframeAPIReady,
            set: (newVal) => {
                if (newVal === null) {
                    apiReadyCallbacks = [];
                }
                else {
                    if (typeof newVal === 'function') {
                        apiReadyCallbacks.push(newVal);
                    }
                    else {
                        throw "onYouTubeIframeAPIReady.set: value was not a function";
                    }
                }
            },
        }
    );
}());